var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-dropzone',{ref:"myVueDropzone",attrs:{"options":_vm.dropzoneOptions,"id":"dropzone"},on:{"vdropzone-success":_vm.success}})
}
var staticRenderFns = []

export { render, staticRenderFns }